/* eslint-disable @typescript-eslint/no-unused-vars */
import { type Resident, ResidentStatus } from '@lmc/ts-common'
import { useSelector } from 'react-redux'
import type {
  IDType,
  ResultType,
  UseFindItemProps,
  UseFindItemReturn
} from './useFindItem'

const getResident = (
  residents: Resident[],
  id: string
): Resident | undefined => {
  const resident = residents.find((resident) => resident.id === id)

  return resident
}

const getResidents = (residents: Resident[], id: string[]): Resident[] => {
  throw new Error('not implemented')
}

/**
 * @deprecated
 *
 * use the new hooks - useResident and useResidentsList
 *
 */
const useResidents = <ID extends IDType>(
  props: UseFindItemProps<ID> = {}
): UseFindItemReturn<Resident, ID> => {
  const { id } = props
  const residents = useSelector(
    (state: { data: { residents: Resident[] } }) => state.data.residents
  )

  const getResult = () => {
    if (!id) {
      return undefined
    }

    if (typeof id === 'string') {
      return getResident(residents, id)
    }

    return getResidents(residents, id)
  }

  const activeResidents = residents?.filter(
    (resident) => resident.status === ResidentStatus.active
  )

  return {
    result: getResult() as ResultType<Resident, ID>,
    all: residents,
    active: activeResidents
  }
}

export default useResidents
